import { render, staticRenderFns } from "./OverlaySession.vue?vue&type=template&id=4220c0d3"
import script from "./OverlaySession.vue?vue&type=script&lang=js"
export * from "./OverlaySession.vue?vue&type=script&lang=js"
import style0 from "./OverlaySession.vue?vue&type=style&index=0&id=4220c0d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports